const getEmailIndex = (CSVData) => {
  const headers = CSVData[0];
  let index;
  for (const i in headers) {
    // find the row that is for emails, and return index
    if (headers[i].toLowerCase().includes('email')) {
      index = i;
    }
  }
  return index > -1 ? index : -1;
};

export const takeEmailColumn = (flashCb, CSVData) => {
  const index = getEmailIndex(CSVData);
  if (index === -1) {
    flashCb('danger', 'Could not find a column for emails in CSV');
    return [];
  }
  const CSVEmails = CSVData.map((row) => row[index]).filter((email) => email !== '');
  return CSVEmails.slice(1)// return an array of emails, sliced to remove header row, filtering out arrays of only empty strings
};

export const validateInputEmails = (emails, flashCb) => {
  const regEx = new RegExp(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/);

  if (typeof emails === 'string') {
    emails = emails.split(',').map((email) => email.trim());
  }

  const invalidEmails = emails.filter((email) => !regEx.test(email));
  if (invalidEmails.length) {
    flashCb(
      'danger',
      `Invalid emails found please reformat:
      ${invalidEmails.map((email) => `'${email}'`).join(', ')}`
    );
    return false;
  }
  return true;
};

export const CSVHeadersForDownload = [
  { label: 'First Name', key: 'firstname' },
  { label: 'Last Name', key: 'lastname' },
  { label: 'Email', key: 'email' },
  { label: 'Role', key: 'role' },
  { label: 'Company', key: 'company' },
  { label: 'Title', key: 'title' },
  { label: 'Membership Created At', key: 'membershipCreatedAt' },
];

export const CSVDataForDownload = (members) => members?.map((member) => {
  return {
    firstname: member.givenName,
    lastname: member.surname,
    email: member?.email || member,
    role: member.role,
    company: member.company,
    title: member.title,
    membershipCreatedAt: moment(member.membershipCreatedAt).format(
      'ddd, MMM Do YYYY, h:mm:ss a'
    )
  };
});

export const nameFile = (page) => {
  const date = String(new Date()).split(' ').join('_').slice(4, 15);
  return `${page}_members_${date}.csv`;
};
